import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledSelectChannelItemContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, errors, selected, disabled, readOnly }) => {
  return {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.customColors.grey[300]}`,
    padding: "16px",
    borderRadius: "4px",
    marginBottom: "12px",
    ...(selected && {
      border: `1px solid ${theme.customColors.purple[500]}`,
    }),
    ...(errors && {
      border: `1px solid ${theme.customColors.pink[600]}`,
    }),
    ...(readOnly && {
      border: `none`,
      padding: "0",
      marginBottom: "8px",
    }),
    "&:last-child": {
      marginBottom: "0", // 最後一個元素的 marginBottom 設為 0
    },
  };
});

export const StyledSelectChannelItemTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, errors, selected, disabled, readOnly }) => {
  return {
    marginRight: "4px",
    fontWeight: 700,
    color: theme.customColors.grey[700],
    ...(disabled && {
      color: theme.customColors.grey[500],
    }),
    ...(readOnly && {
      fontWeight: 500,
    }),
  };
});
